import { publish, switchMap, takeUntil } from "rxjs/operators";
export function switchMapUntil(prelude, project) {
    return (source) => source.pipe(publish((shared) => shared.pipe(prelude, switchMap((value, index) => project(value, index).pipe(takeUntil(shared))))));
}
//# sourceMappingURL=switchMapUntil.js.map